import instance from './axios'
export const createUploadApi = (url, method, data) => {
  let config = {}
  config.data = data
  config.headers = {
    'Content-Type': 'multipart/form-data;charset=UTF-8'
  }
  config.responseType = 'json'
  return instance({
    url,
    method,
    ...config
  })
}

export const createApi = (url, method, data) => {
  let config = {}
  if (method === 'get') {
    config.params = data
  } else {
    config.data = data
  }
  return instance({
    url,
    method,
    ...config
  })
}

// 这是我写的
export const createSerachImageApi = (url, method, data) => {
  let config = {}
  if (method === 'get') {
    config.params = data
  } else {
    config.data = data
    config.responseType = 'blob'
  }
  return instance({
    url,
    method,
    ...config
  })
}

export const createFormApi = (url, method, data) => {
  let config = {}
  config.data = data
  config.headers = {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  config.responseType = 'json'
  config.transformRequest = [
    function (data) {
      let value = ''
      for (const item in data) {
        value += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
      }
      return value
    }
  ]
  return instance({
    url,
    method,
    ...config
  })
}

export const createImgApi = (url, method, data) => {
  let config = {}
  config.data = data
  config.headers = {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  config.responseType = 'blob'
  config.transformRequest = [
    function (data) {
      let value = ''
      for (let item in data) {
        value += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
      }
      return value
    }
  ]
  return instance({
    url,
    method,
    ...config
  })
}

export const createFileApi = (url, method, data) => {
  let config = {}
  config.data = data
  config.headers = {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  config.responseType = 'arraybuffer'
  config.transformRequest = [
    function (data) {
      let value = ''
      for (let it in data) {
        value += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return value
    }
  ]
  return instance({
    url,
    method,
    ...config
  })
}

export const createDownApi = (url, method, data) => {
  let config = {}
  if (method === 'get') {
    config.params = data
  } else {
    config.data = data
  }
  config.headers = {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  config.responseType = 'blob'
  return instance({
    url,
    method,
    ...config
  })
}



// WEBPACK FOOTER //
// ./src/utils/apiWrap.js